export const GENERAL_ROUTE_NAMES = {
    NOT_FOUND: "NotFound",
    DEFAULT: "DefaultRoute",
    DASHBOARD: "Dashboard",
};
